module.exports = __webpack_public_path__ + "static/media/shopping-cart.36cf25f3.svg";